import { useMapContext } from '../../contexts/MapContext';
import LinearProgress from '@mui/material/LinearProgress';
import {useState, useEffect, useCallback} from "react";
import {CircularProgress} from "@mui/material";
import {getModelProgress, getModelStatus} from "../../api/graphql";

const ProgressPanel = () => {
    // TODO move this back here maybe?
    // const [progressValue, setProgressValue] = useState(-2); // Kaming: I moved this to the MapContext.js
    const [errorMessage, setErrorMessage] = useState("");
    const {
        devPlanID,
        selectedStormOption,
        planHasBeenRun,
        setPlanIsRunning,
        planIsRunning,
        containPlan,
        userData,
        setPlanHasBeenRun,
        setModelDoneRunning,
        progressValue, 
        setProgressValue,
    } = useMapContext();


    const updateProgressCallback = useCallback(() => {
        const updateProgress = async () => {
            if (!devPlanID) {
                console.log("No Development Plan ID available");
                setProgressValue(-2);
                setPlanIsRunning(false);
                return;
            }

            const progress = await getModelProgress(devPlanID);

            if (progress === -2) {
              setPlanIsRunning(false);
              setProgressValue(-2);
              return;
            }

            if (!planHasBeenRun) setPlanIsRunning(true);
            setProgressValue(progress);
        }
        updateProgress();
    }, [devPlanID, selectedStormOption]);



    // Kaming: the GI panel does not immediately show up because of the state update delay of planHasBeenRun. (originally needs to wait for 30s)
    // added this if statement to speed up the state update
    // TODO is there a better way to do this?
    useEffect(() => {
        if (userData) {
            // If the plan is found in S3 bucket kensho-result, the plan has been run.
            if (containPlan(selectedStormOption, userData.id, devPlanID)) {
                setPlanHasBeenRun(true);
            } else if (!planIsRunning && !containPlan(selectedStormOption, userData.id, devPlanID)) {
                // If the plan is NOT currently running and NOT found in S3 kensho-result, ie. a newly created plan
                setPlanHasBeenRun(false);
            }
            console.log("### None of the conditions, planIsRunning: ", planIsRunning);
        }
    }, [userData, selectedStormOption, devPlanID, planIsRunning]);



    // Initial update
    useEffect(() => {
        updateProgressCallback();
    }, [updateProgressCallback]);

    // Run every 30 seconds while this component is loaded.
    useEffect(() => {
        const intervalId = setInterval(() => {
            updateProgressCallback();
        }, 30000); // 30 seconds in milliseconds

        return () => clearInterval(intervalId);
    }, [updateProgressCallback]);

    useEffect(() => {
        setPlanIsRunning(progressValue >= 0 && progressValue < 99);

        if ((progressValue > 99) && (progressValue < 105)) { // model done running
            setModelDoneRunning(true);
        }
    }, [progressValue]);

    // If the progress value becomes 105 (error) update the error message.
    useEffect( () => {
        const fetchModelStatus = async () => {
          const status = await getModelStatus(devPlanID);
          if (status) {
            setErrorMessage(status);
          }
        };
        if (progressValue === 105) {
            fetchModelStatus();
        }
    }, [progressValue])

    // Error with running model
    if (progressValue === 105) {
        return (
            <div style={{
                zIndex: "1000",
                width: '200px',
                position: 'absolute',
                top: '50px',
                left: '50%',
                transform: 'translateX(-50%)',
                padding: '10px',
                display: 'flex',
                flexDirection: 'column',
                textAlign: 'center',
                backgroundColor: 'rgba(0, 0, 0, 0.75)',
                borderRadius: '5px',
                fontSize: '1em',
                fontWeight: 'bold',
            }}>
                Error while running model.
                <div style={{marginTop: '5px', fontWeight: 'normal'}}>
                    {errorMessage}
                </div>
            </div>
        );
    }

    if (!planIsRunning) {
        return null;
    }

    if (progressValue === -2) {
        return (
            <div style={{
                zIndex: "1000",
                width: '200px',
                position: 'absolute',
                top: '50px',
                left: '50%',
                transform: 'translateX(-50%)',
                padding: '10px',
                display: 'flex',
                flexDirection: 'column',
                textAlign: 'center',
                alignItems: 'center',
                justifyContent: 'space-between',
                backgroundColor: 'rgba(0, 0, 0, 0.75)',
                borderRadius: '5px',
                fontSize: '1em',
                fontWeight: 'bold',
            }}>
                Waiting for model to start...
                <CircularProgress/>
            </div>
        );
    }


    return (
        <div style={{
            zIndex: "1000",
            width: '200px',
            position: 'absolute',
            top: '50px',
            left: '50%',
            transform: 'translateX(-50%)',
            padding: '10px',
            display: 'flex',
            flexDirection: 'column',
            textAlign: 'center',
            backgroundColor: 'rgba(0, 0, 0, 0.75)',
            borderRadius: '5px',
            fontSize: '1em',
            fontWeight: 'bold',
        }}>
            Running your plan...
            <LinearProgress variant="determinate" value={progressValue}/>
            <div style={{marginTop: '5px'}}>
                {`${Math.round(progressValue)}%`}
            </div>
        </div>
    );
};

export default ProgressPanel;
